<template>
    <div id="email_select">
        <div class="md:tw-inline-block tw-relative tw-ml-2">
            <button id="assignToDepartmentButton" type="button" @click="isDropdownOpen = ! isDropdownOpen" class="cu-btn tw-relative tw-mb-1">
                <i class="fa fa-spinner fa-pulse tw-mr-1" v-show="isLoading"></i>
                An Abteilung übergeben
                <i class="fa fa-chevron-down tw-ml-1"></i>
            </button>

            <div id="assignToDepartmentDropdown" 
                class="tw-border tw-rounded tw-no-underline tw-flex tw-flex-wrap tw-bg-white tw-absolute tw-overflow-auto tw-z-20 tw-rounded-mdtw-border tw-border-navbar-secondary" 
                v-show="isDropdownOpen"
                v-closable="{
                    exclude: ['#assignToDepartmentButton'],
                    handler: 'onClose'
                }"
            >
                <div class="tw-w-full tw-py-2 tw-px-4 hover:tw-bg-brand-primary hover:tw-text-white tw-cursor-pointer"
                     v-for="department in departments"
                     @click="onDepartmentSelect(department)"
                >
                    {{ department.name }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            formEndpoint: {
                required: true,
                type: String,
            },
            departments: {
                required: true,
                type: Array,
            },
            applicationMailId: {
                required: true,
                type: Number,
            },
            departmentId: {
                required: false,
                type: Number,
                default: 0,
            }
        },

        data() {
            return {
                isDropdownOpen: false,
                isLoading: false,
            }
        },

        methods: {
            onClose() {
                this.isDropdownOpen = false;
            },
            onDepartmentSelect(department) {
                this.isDropdownOpen = false;
                this.isLoading = true;

                axios
                    .post(this.formEndpoint, {
                        department_id: [department.id],
                        mail_id: this.applicationMailId,
                        current_department_id: this.departmentId,
                    })
                    .then(response => {
                        this.isLoading = false;
                        window.location.href = response.data.redirectTo;
                    })
                    .catch(error => {
                        alert('Es trat ein unerwarteter Fehler auf.')
                    })
                    .then(() => {
                        this.isLoading = false;
                    });

            }
        }
    }
</script>
